export const GET_PRODUCTTYPES_STATED = "GET_PRODUCTTYPES_STATED";
export const GET_PRODUCTTYPES = "GET_PRODUCTTYPES";
export const GET_PRODUCTTYPES_ENDED = "GET_PRODUCTTYPES_ENDED";
export const ADD_PRODUCTTYPE_STATED = "ADD_PRODUCTTYPE_STARTED";
export const ADD_PRODUCTTYPE = "ADD_PRODUCTTYPE";
export const ADD_PRODUCTTYPE_ENDED = "ADD_PRODUCTTYPE_ENDED";
export const EDIT_PRODUCTTYPE_STATED = "EDIT_PRODUCTTYPE_STATED";
export const EDIT_PRODUCTTYPE = "EDIT_PRODUCTTYPE";
export const EDIT_PRODUCTTYPE_ENDED = "EDIT_PRODUCTTYPE_ENDED";
export const GET_PRODUCTTYPE = "GET_PRODUCTTYPE";
export const GET_PRODUCTTYPE_STATED = "GET_PRODUCTTYPE_STATED";
export const GET_PRODUCTTYPE_ENDED = "GET_PRODUCTTYPE_ENDED";
export const RESET_PRODUCTTYPE = "RESET_PRODUCTTYPE";
export const ERROR_PRODUCTTYPE = "ERROR_PRODUCTTYPE";
export const GET_ALL_PRODUCTTYPES_STATED = "GET_ALL_PRODUCTTYPES_STATED";
export const GET_ALL_PRODUCTTYPES = "GET_ALL_PRODUCTTYPES";
export const GET_ALL_PRODUCTTYPES_ENDED = "GET_ALL_PRODUCTTYPES_ENDED";
